import * as Sentry from '@sentry/react';

export const initializeSentry = (sentryDsn) => {
  Sentry.init({
    dsn: sentryDsn,
    integrations: [],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [/^\//, /^https:\/\/www\.kellfri\.com\/api/],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
};
